import {Injectable} from '@angular/core';
import {HttpService} from '../../../../services/http.service';

@Injectable()
export class AvrcsSearchDialogService {
    avrcsVendorsUrl = 'api/preparation/avrcs-vendor';

    constructor(private httpService: HttpService) {
    }

    avrcsVendorsData(searchData) {
        let searchParam = '';
        for (const key in searchData) {
            if (searchData[key]) {
                searchParam += key + '=' + searchData[key] + '&';
            }
        }
        return this.httpService.get(this.avrcsVendorsUrl + '?' + searchParam, {observe: 'response'});
    }

    convertToSearchParams(criteria: any) {
        let searchParam = '';
        for (const key in criteria) {
            if (criteria[key]) {
                searchParam += key + '=' + criteria[key] + '&';
            }
        }
        return searchParam;
    }

}
